import React from 'react'
import "./Current_rank_main_card.css"
import Current_rank_main_card_lottie from '../../../../animations/current_rank_main_card_lottie/Current_rank_main_card_lottie'

function Current_rank_main_card() {
    return (
        <>
            <section className='Current_rank_main_card'>
                <div className="row">
                    <div className="col-md-6 col-sm-6 col-6">
                        <div className="text_holder">
                            <div>
                                <h6>Current Rank: </h6>
                                <h1>Gold Star</h1>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 col-sm-6 col-6">
                        <div className="img_holder">
                            <img src="/assets/images/profile/current_rank/current_rank_main_card/star.png" alt="" className='star_img' />
                        </div>
                    </div>
                </div>
                <div className="Current_rank_main_card_lottie_holder">
                    <Current_rank_main_card_lottie />
                    <Current_rank_main_card_lottie />

                </div>
            </section>
        </>
    )
}

export default Current_rank_main_card